import { _ } from "../../core/polyglot/polyglot.js";
import AbstractBusinessTrendComparisonElement from "./AbstractBusinessTrendComparisonElement.js";

/**
 * Represents a forecast for the user to compare to the current fiscal
 * year.
 *
 * @param {Forecast} forecast
 */
export default class ForecastingTrendComparisonElement extends AbstractBusinessTrendComparisonElement {
	constructor({ forecast }) {
		super(...arguments);

		this._forecast = forecast;
	}

	getId() {
		return this._forecast.getId();
	}

	getGroupName() {
		return _("Published forecasts");
	}

	getName() {
		return this._forecast.getName();
	}

	fetchAnnualTrend({ fetchAnnualTrendForForecast }) {
		return fetchAnnualTrendForForecast(this._forecast);
	}

	getNameRenderer({ router }) {
		const url = this._pageUrl(router);
		const name = this.getName();

		return (html) => html.a({ href: url }, name);
	}

	getPeriodNameRenderer({ router }) {
		return _("the forecast {forecastName} in {period}", {
			forecastName: this.getNameRenderer({ router }),
			period: super.getPeriodNameRenderer(...arguments),
		});
	}

	_pageUrl(router) {
		return router.linkTo("forecast-viewer/#forecastId", {
			forecastId: this.getId(),
		});
	}

	_getFiscalYear() {
		return this._forecast.getCurrentPeriod().getFiscalYear();
	}
}
